/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
export function parse(html) {
  let detachedDoc = document.implementation.createHTMLDocument('title');
  let elm = detachedDoc.createElement('div');
  elm.innerHTML = sanitizeHtml(html, {
    config: 'inboxComposer'
  });
  return elm;
}
export function walk(node, skip, func) {
  func(node);
  let childNode = node.firstChild;
  while (childNode) {
    let next = childNode.nextSibling;
    if (!skip.includes(childNode.nodeName)) {
      walk(childNode, skip, func);
    }
    childNode = next;
  }
}